import { contentContext } from './content-catalog.mjs';

export function entrySource(referrer, origin) {
  if (!referrer) return 'direct';
  try {
    const url = new URL(referrer);
    if (url.origin === origin) return 'internal';
    if (/(^|\.)(chatgpt\.com|perplexity\.ai|claude\.ai|gemini\.google\.com|copilot\.microsoft\.com)$/.test(url.hostname)) return 'ai';
    if (/(^|\.)(google\.(?:com|[a-z]{2}|com\.[a-z]{2}|co\.[a-z]{2})|bing\.com|duckduckgo\.com|search\.yahoo\.com)$/.test(url.hostname)) return 'search';
    return 'referral';
  } catch { return 'direct'; }
}

// Only called after consent. Last public content touch, in this tab, for 30 minutes.
export function createContentAttribution({ storage, now = Date.now }) {
  const key = 'musicmint:content-attribution:v1';
  function clear() { try { storage().removeItem(key); } catch {} }
  function current() {
    try {
      const row = JSON.parse(storage().getItem(key) || 'null');
      if (!row || !Number.isFinite(row.at) || now() - row.at > 1800000 || row.at > now()) { clear(); return {}; }
      const ctx = contentContext(row.path);
      if (!ctx.content_id) { clear(); return {}; }
      return { ...ctx, entry_source: ['search', 'ai', 'referral', 'direct', 'internal'].includes(row.entry_source) ? row.entry_source : 'direct' };
    } catch { return {}; }
  }
  function visit(path, source = 'internal', locale = '') {
    if (/^\/(?:[a-z-]+\/)?share\//i.test(path)) { clear(); return {}; }
    const ctx = contentContext(path);
    if (!ctx.content_id) return current();
    const language = locale === 'zh-TW' ? 'zh-TW' : locale.split('-')[0];
    if (ctx.content_source === 'tool' && ['en', 'zh', 'zh-TW', 'ja', 'ko', 'fr', 'de', 'es'].includes(language)) ctx.content_locale = language;
    const previous = current();
    const entry = ['internal', 'direct'].includes(source) ? previous.entry_source || source : source;
    try { storage().setItem(key, JSON.stringify({ path: `/${ctx.content_locale}/${ctx.content_id}`, at: now(), entry_source: entry })); } catch {}
    return current();
  }
  return { current, visit, clear };
}
